import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import Psicopedagogia from '.';

type Props = RouteComponentProps<{}>;

const PsicopedagogiaPrincipal: React.FunctionComponent<Props> = props => {
    return (
        <div>
            <Psicopedagogia />
        </div>
    );
};

export default PsicopedagogiaPrincipal;



// WEBPACK FOOTER //
// ./src/modulos/Psicopedagogia/PsicopedagogiaPrincipal.tsx